import styles from './styles.module.scss';

const SpinnerLoader = () => <div className={styles.spinner} />;

export default SpinnerLoader;
